import { lazyRemoveFavoriteCategory } from 'owa-favorites';
import {
    lazyRemoveFavoritePersona,
    lazyHandleToggleFavoritePersonaError,
} from 'owa-mail-favorites-store';
import type { MailboxInfo } from 'owa-client-types';
import type { ActionSource } from 'owa-mail-store';

export const removeFavoriteCategory = async (
    categoryId: string,
    mailboxInfo: MailboxInfo,
    actionSource: ActionSource
): Promise<void> => {
    const removeFavoriteCategoryFunc = await lazyRemoveFavoriteCategory.import();
    removeFavoriteCategoryFunc(categoryId, actionSource ?? 'ContextCategory', mailboxInfo);
};

export const removeFavoritePersona = (
    favoriteId: string,
    mailboxInfo: MailboxInfo,
    actionSource: ActionSource
): void => {
    lazyRemoveFavoritePersona
        .importAndExecute(favoriteId, actionSource ?? 'ContextPersona', mailboxInfo)
        .catch(() => lazyHandleToggleFavoritePersonaError.importAndExecute(true));
};
